module.exports = __webpack_public_path__ + "img/unionpay.31abc16c.png";